import { call, put, takeLatest, select } from 'redux-saga/effects';

import ApiRouts from '../../api/routes';
import { DELETE } from "../../api";
import {
    FETCH_DISLIKE,
    SET_DISLIKE,
} from "../actions";


const getDislikeFormId = (state) => state.likeFormId;


export function* FetchDislikeSaga() {


    const likeFormId = yield select(getDislikeFormId);


    try {
        const response = yield call(DELETE, `${ApiRouts.API_LIKE}/${likeFormId}`);

        if (response) {

            yield put({
                type: SET_DISLIKE,
                payload: response.data.data
            });

            // yield put({ type: FETCH_PRODUCT_LIST });
            // yield put({ type: FETCH_SHOW_MORE_PRODUCT_LIST });   



        } else {
            throw new Error('Failed to fetch the latest version');
        }

    } catch (error) {

        if (error.response.status === 401) {
            localStorage.removeItem('edexLicenceToken');
        }

        // yield put(setError(error.message));  // Set error if something goes wrong
        // yield put(setLoading(false));  // End loading in case of error
    }
}

// Watcher Saga
function* dislikeSaga() {
    yield takeLatest(FETCH_DISLIKE, FetchDislikeSaga);
}

export default dislikeSaga;
